import { ModulosEnumChoice, TABLE_CONSTANTS, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { GeneralTable, useModalMotivoRechazo } from "@/shared/components/ui";
import ModalMotivoRechazo from "@/shared/components/ui/ModalMotivoRechazo/ModalMotivoRechazo";
import { Grid, IconButton, Tooltip } from "@mui/material";
// import { useNavigate } from "react-router-dom";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useFetchContratos } from "@/shared/actions/erp";
import { Contrato } from "@/shared/interfaces";
import { useTableColumnsContrato } from "@/shared/hooks/useTableColumnsContrato";

export default function TableClientesBras() {

  ///* Hook
  const { columnsContrato } = useTableColumnsContrato();


  // const navigate = useNavigate();

  const useHookModalMotivoRechazo = useModalMotivoRechazo({
    modulo: ModulosEnumChoice.PREVENTA
  })

  const {
    pagination,
    searchTerm,
    dateBefore,
    dateAfter,
    setPagination,

    vendedor,
  } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;

  const { isLoading, data: contratosRes,
    isRefetching, } = useFetchContratos(
      {
        enabled:true,
        params:{
          bras_isnull:false,//para obtener solo contratos que tienen bras
          //requiere_contrato_fisico: true,
          identificacion: searchTerm,
          page: pageIndex + 1,
          page_size: pageSize,
          fecha_preventa_before: dateBefore,
          fecha_preventa_after: dateAfter,
          user_create: vendedor,
          ...filterObject,
          filterByState: false
        }
      }
    );


  return (
    <>
      <Grid container spacing={2}>
        {/* <Grid item xs={12}>
          <CustomSearchFilterSupervisorVenta
            onChange={onChangeFilter}
            value={globalFilter}
            text="por Identificación"
            onChangeRangeDate={onChangeRangeDate}
            cleanFilter={cleanFilter}
            setVendedor={setVendedor}
          />
        </Grid> */}
        <Grid item xs={12}>
          <GeneralTable<Contrato>
            columns={columnsContrato}
            data={contratosRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={contratosRes?.data?.count}

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}

            // // actions
            // crud
            canDelete={false}
            positionActionsColumn='first'
            canEdit={false}
            enableEditing={true}

            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_SMALL}
            showCustomActionBtnSpace={true}
            customActionBtnSpace={(value) => {
              return (
                <>
                  <Tooltip placement='top' title='Ver Contrato'>
                    <IconButton
                      onClick={() => {
                        //setOpenModal(true)
                        //if (!value.contrato_data) return;
                        //descargarPdfDesdeurl(value.contrato_data?.url_contrato, `${value.numero_referencia}.pdf`);
                        alert("Posible visualización de detalles: "+value?.cliente_data?.razon_social)
                      }}
                    >
                      <VisibilityIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                </>
              )
            }
            }

          />
        </Grid>
      </Grid>

      <ModalMotivoRechazo
        {...useHookModalMotivoRechazo}
      />


    </>
  )

}